import { colors, fonts } from "../../styles/theme";

export const inputStyle = {
  width: "100%",
  padding: "9px 12px",
  fontSize: 13,
  fontFamily: fonts.body,
  border: `1px solid ${colors.border}`,
  borderRadius: 6,
  background: colors.bg,
  color: colors.text,
  outline: "none",
  boxSizing: "border-box",
};

// Default roles per page (mirrors NAV_ITEMS in App.jsx)
export const DEFAULT_PAGE_ROLES = {
  "/": ["exec", "admin"],
  "/contacts": ["sales", "exec", "admin"],
  "/review": ["exec", "admin"],
  "/companies": ["exec", "admin"],
  "/catalog": ["exec", "admin"],
  "/client-access": ["sales", "exec", "admin"],
  "/invoices": ["sales", "exec", "admin"],
  "/pipeline": ["sales", "exec", "admin"],
  "/newsletters": ["exec", "admin"],
  "/events": ["exec", "admin"],
  "/engagement": ["exec", "admin"],
  "/network": ["exec", "admin"],
  "/videos": ["exec", "admin"],
  "/video-library": ["exec", "admin"],
  "/downloads": ["exec", "admin"],
  "/documents": ["exec", "admin"],
  "/enhancements": ["exec", "admin"],
  "/help": ["sales", "exec", "admin"],
  "/settings": ["admin"],
  "/it-admin": ["admin"],
  "/email-health": ["admin"],
  "/audit-log": ["admin"],
};

// Default mapping + priority (mirrors api/shared/contact-utils.js)
export const DEFAULTS = {
  mapping: {
    "fgf advisory client": "advisory_client",
    "fgf chairman's access client": "chairmans_access",
    "fgf chairman's access": "chairmans_access",
    "partner/collaborator": "partner",
    partner: "partner",
    vip: "vip",
    "active discussion": "active_discussion",
    prospect: "prospect",
    "fgf opportunity": "prospect",
    "interest in ca": "prospect",
    "a list": "prospect",
    "webcast interest": "prospect",
    "still interested": "prospect",
    lead: "lead",
    press: "media",
    "former client": "former_client",
    ffgf: "ffgf",
    "academia np": "non_paying",
    "gov/state np": "non_paying",
    fgf: "team",
    inactive: "inactive",
  },
  priority: [
    "advisory_client",
    "chairmans_access",
    "partner",
    "vip",
    "active_discussion",
    "prospect",
    "lead",
    "media",
    "former_client",
    "ffgf",
    "non_paying",
    "team",
    "inactive",
  ],
};

export const SPACING_DEFAULTS = {
  h1Above: 24, h1Below: 12,
  h2Above: 20, h2Below: 10,
  h3Above: 16, h3Below: 8,
  pBelow: 12,
};

export const SPACING_FIELDS = [
  { key: "h1Above", label: "Heading 1 — above" },
  { key: "h1Below", label: "Heading 1 — below" },
  { key: "h2Above", label: "Heading 2 — above" },
  { key: "h2Below", label: "Heading 2 — below" },
  { key: "h3Above", label: "Heading 3 — above" },
  { key: "h3Below", label: "Heading 3 — below" },
  { key: "pBelow", label: "Paragraph — below" },
];

export const MANAGEABLE_PAGES = [
  { path: "/", label: "Dashboard" },
  { path: "/contacts", label: "Contacts" },
  { path: "/review", label: "Review" },
  { path: "/companies", label: "Companies" },
  { path: "/catalog", label: "Products" },
  { path: "/client-access", label: "Client Access" },
  { path: "/invoices", label: "Invoices" },
  { path: "/pipeline", label: "Pipeline" },
  { path: "/newsletters", label: "Newsletters" },
  { path: "/events", label: "Webcasts" },
  { path: "/engagement", label: "Engagement" },
  { path: "/network", label: "Network" },
  { path: "/videos", label: "Videos" },
  { path: "/video-library", label: "Clip Library" },
  { path: "/downloads", label: "Downloads" },
  { path: "/documents", label: "Documents" },
  { path: "/enhancements", label: "Enhancements" },
  { path: "/help", label: "Help" },
];
